module.exports = __webpack_public_path__ + "img/48600.22c73db4.jpg";